const regionDisplayOptions = [
  { value: 'state', label: 'States' },
  { value: 'msa', label: 'States + Metro Areas' },
]

export default regionDisplayOptions
